import { reactive } from 'vue'
import { MenuComputer, Dropdown } from '@/types'
import { AssetUploader } from '@/composables/upload'
export const filesRepository: { [key: string]: Array<AssetUploader> } =
  reactive({})
export const menuComputers: MenuComputer[] = []
export const dropdowns: Dropdown[] = reactive([])
